<template>
  <div class="app-main">
    <keep-alive>
      <transition
        name="fade-transform"
        mode="out-in"
        v-if="$route.meta.keepAlive"
      >
        <router-view ref="view" />
      </transition>
    </keep-alive>
    <transition
      name="fade-transform"
      mode="out-in"
      v-if="!$route.meta.keepAlive"
    >
      <router-view ref="view" />
    </transition>
    <div
      class="guide-icon-container"
      v-drag
      @click="drawer = true"
      v-if="isStudent"
    ></div>
    <el-drawer :visible.sync="drawer" direction="rtl">
      <operation-guide></operation-guide>
    </el-drawer>
  </div>
</template>

<script>
import OperationGuide from "@/components/OperationGuide/index";
export default {
  name: "AppMain",
  components: { OperationGuide },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      isStudent: false,
      drawer: false,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let category = userInfo.category;
    this.isStudent = category == "student";
  },
};
</script>
